import React, {Component} from 'react';
import OperationalPortfolioStatus from "../components/tables/operationalPortfolioStatus";
import OperationalPortfolioStatusGraph from "../charts/operationalPortfolioStatusGraph"

import * as dataService from "../service/data-info-chart/requestsUtil"
import {PERFORMANCE_ANALYSIS, PORTFOLIO_STATUS_OPERATION, WHITOUT_INFORMATION} from "../utils/constants";
import * as cbu from "../utils/checkBusinessUnit";

var Loader = require('react-loader')

class PotentialBillingIncreaseComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {data: [], loaded: false}
  }

  componentDidMount() {
    dataService.getFetch(PERFORMANCE_ANALYSIS + cbu.checkBusinessUnit(this.props.bu) + PORTFOLIO_STATUS_OPERATION)
      .then((json) => {
        this.setState({data: json, loaded: true})
      });
  }

  render() {
    if (this.state.data.length > 0) {
      return (
        <div>
          <OperationalPortfolioStatusGraph data={this.state.data}/>
          <OperationalPortfolioStatus data={this.state.data} striped={true}/>
        </div>
      );
    } else {
      return (<h2 className="without-avilable-information">{WHITOUT_INFORMATION}</h2>);
    }

  }
}

export default PotentialBillingIncreaseComponent;




// WEBPACK FOOTER //
// ./src/components/deletedAccountsClassificationComponent.js